const FgiInfo = {
  email: 'digital.solutions@hr-path.com',
  phone: '+49 40 656 89 00',
};

export default FgiInfo;
